import React from "react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };
const SERIF = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

const NUMPAD = [
  ["7", "8", "9", "÷"],
  ["4", "5", "6", "×"],
  ["1", "2", "3", "-"],
  [".", "0", "⌫", "+"],
];

function fmt(n, d = 2) {
  return Number(n).toLocaleString("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function BudgetCalculator({ expr, currSymbol, isLocal, currency, info, curVal, eurVal, onCalc, onToggleCurrency }) {
  return (
    <div className="bg-white border border-[#DCD4C6] p-4 mb-3" style={{ borderRadius: "3px" }}>
      {/* Header + currency toggle */}
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs uppercase tracking-widest text-[#8B5E34]" style={LORA}>Calculatrice</p>
        {currency !== "EUR" && (
          <button
            onClick={onToggleCurrency}
            className="flex items-center gap-1.5 px-2.5 py-1 border border-[#C17F59]/40 text-[#C17F59] text-xs hover:bg-[#C17F59]/8 transition-colors"
            style={{ ...LORA, borderRadius: "2px" }}
            data-testid="btn-currency-toggle"
          >
            {isLocal ? `${info.flag} ${currency} → €` : `€ → ${info.flag} ${currency}`}
          </button>
        )}
      </div>

      {/* Display */}
      <div
        className="text-right p-3 mb-3 min-h-[64px] border border-[#DCD4C6] bg-[#FAF7F3]"
        style={{ borderRadius: "2px" }}
      >
        <p
          className="text-3xl text-[#2B2623] break-all"
          style={{ ...SERIF, fontWeight: 600 }}
          data-testid="calc-display"
        >
          {expr || "0"} <span className="text-xl text-[#9A8F86]">{currSymbol}</span>
        </p>
        {isLocal && currency !== "EUR" && curVal > 0 && (
          <p className="text-sm text-[#9A8F86] mt-0.5" style={LORA} data-testid="calc-eur-equivalent">
            ≈ {fmt(eurVal)} €
          </p>
        )}
      </div>

      {/* Numpad */}
      <div className="grid grid-cols-4 gap-1.5">
        {NUMPAD.flat().map((key) => (
          <button
            key={key}
            onClick={() => onCalc(key)}
            className={`py-4 text-center text-xl active:scale-95 transition-all select-none ${
              ["+", "-", "×", "÷"].includes(key)
                ? "bg-[#F1EBE1] text-[#C17F59] hover:bg-[#E8DDD2]"
                : key === "⌫"
                ? "bg-[#FAF7F3] text-[#8B5E34] hover:bg-[#F1EBE1]"
                : "bg-[#FAF7F3] text-[#2B2623] hover:bg-[#F1EBE1]"
            }`}
            style={{ ...SERIF, fontWeight: 600, borderRadius: "2px" }}
            data-testid={`calc-btn-${key === "÷" ? "div" : key === "×" ? "mul" : key === "⌫" ? "back" : key}`}
          >
            {key}
          </button>
        ))}
        <button
          onClick={() => onCalc("C")}
          className="col-span-2 py-4 text-center text-xl bg-[#FEF2F2] text-[#DC2626] hover:bg-[#FEE2E2] active:scale-95 transition-all select-none"
          style={{ ...SERIF, fontWeight: 600, borderRadius: "2px" }}
          data-testid="calc-btn-clear"
        >
          C
        </button>
        <button
          onClick={() => onCalc("=")}
          className="col-span-2 py-4 text-center text-xl bg-[#C17F59] text-[#F9F6F0] hover:bg-[#A86A46] active:scale-95 transition-all select-none"
          style={{ ...SERIF, fontWeight: 600, borderRadius: "2px" }}
          data-testid="calc-btn-equals"
        >
          =
        </button>
      </div>
    </div>
  );
}
